var _rect, _rect2, _rect3, _rect4, _rect5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPleated2A(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    enableBackground: "new 0 0 80 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -0.1,
    fill: "none",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 80,
    height: 80.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.9,
    y: 10,
    fill: "none",
    width: 60,
    height: 59.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9.7,
    fill: "none",
    width: 60,
    height: 60.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9.8,
    fill: "none",
    width: 60,
    height: 59.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    fill: "#D2D2D2",
    width: 60,
    height: 59.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: 9.9,
    y: 10.2,
    width: 60.1,
    height: 59.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    stroke: "#716F6F",
    strokeWidth: 0.6245,
    strokeMiterlimit: 10,
    d: "M14.6,11.6c-0.3,1.7-2.5,15.1-2.6,18.8 c-0.1,2.6-0.2,21.3-0.2,21.3l-0.2,16.2l-0.3,3.5l8.7,0.5l-0.3-20.2l-0.3-17.1c0-0.1-0.1-4.1-0.1-4.2c-0.1-3-2.8-16.3-3-18.6 C16.2,10.7,14.8,10.4,14.6,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D9D9C",
    d: "M14.3,27.7c0,0,2.6-2.5,2.9-1c0.2,0.7-1.4-7.6-1.4-7.6l-0.3-5.9l-0.3,7.3L14.3,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#716F6F",
    strokeWidth: 0.563,
    strokeMiterlimit: 10,
    d: "M14.4,28c0,0,1.2-14.8,1.1-15.3 c-0.1-0.4-0.3,5,0.8,8.9c0.4,1.5,1.2,6.4,1.2,6.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    stroke: "#716F6F",
    strokeWidth: 0.6245,
    strokeMiterlimit: 10,
    d: "M26.6,11.6c-0.3,1.7-2.5,15.1-2.6,18.8 c-0.1,2.6-0.2,21.3-0.2,21.3l-0.2,16.2l-0.3,3.5l8.7,0.5l-0.3-20.2l-0.3-17.1c0-0.1-0.1-4.1-0.1-4.2c-0.1-3-2.8-16.3-3-18.6 C28.2,10.7,26.8,10.4,26.6,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D9D9C",
    d: "M26.3,27.7c0,0,2.6-2.5,2.9-1c0.2,0.7-1.4-7.6-1.4-7.6l-0.3-5.9l-0.3,7.3L26.3,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#716F6F",
    strokeWidth: 0.563,
    strokeMiterlimit: 10,
    d: "M26.4,28c0,0,1.2-14.8,1.1-15.3 c-0.1-0.4-0.3,5,0.8,8.9c0.4,1.5,1.2,6.4,1.2,6.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    stroke: "#716F6F",
    strokeWidth: 0.6245,
    strokeMiterlimit: 10,
    d: "M38.6,11.6c-0.3,1.7-2.5,15.1-2.6,18.8 c-0.1,2.6-0.2,21.3-0.2,21.3l-0.2,16.2l-0.3,3.5l8.7,0.5l-0.3-20.2l-0.3-17.1c0-0.1-0.1-4.1-0.1-4.2c-0.1-3-2.8-16.3-3-18.6 C40.2,10.7,38.8,10.4,38.6,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D9D9C",
    d: "M38.3,27.7c0,0,2.6-2.5,2.9-1c0.2,0.7-1.4-7.6-1.4-7.6l-0.3-5.9l-0.3,7.3L38.3,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#716F6F",
    strokeWidth: 0.563,
    strokeMiterlimit: 10,
    d: "M38.4,28c0,0,1.2-14.8,1.1-15.3 c-0.1-0.4-0.3,5,0.8,8.9c0.4,1.5,1.2,6.4,1.2,6.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    stroke: "#716F6F",
    strokeWidth: 0.6245,
    strokeMiterlimit: 10,
    d: "M50.6,11.6c-0.3,1.7-2.5,15.1-2.6,18.8 c-0.1,2.6-0.2,21.3-0.2,21.3l-0.2,16.2l-0.3,3.5l8.7,0.5l-0.3-20.2l-0.3-17.1c0-0.1-0.1-4.1-0.1-4.2c-0.1-3-2.8-16.3-3-18.6 C52.2,10.7,50.8,10.4,50.6,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D9D9C",
    d: "M50.3,27.7c0,0,2.6-2.5,2.9-1c0.2,0.7-1.4-7.6-1.4-7.6l-0.3-5.9l-0.3,7.3L50.3,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#716F6F",
    strokeWidth: 0.563,
    strokeMiterlimit: 10,
    d: "M50.4,28c0,0,1.2-14.8,1.1-15.3 c-0.1-0.4-0.3,5,0.8,8.9c0.4,1.5,1.2,6.4,1.2,6.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    stroke: "#716F6F",
    strokeWidth: 0.6245,
    strokeMiterlimit: 10,
    d: "M62.6,11.6c-0.3,1.7-2.5,15.1-2.6,18.8 c-0.1,2.6-0.2,21.3-0.2,21.3l-0.2,16.2l-0.3,3.5l8.7,0.5l-0.3-20.2l-0.3-17.1c0-0.1-0.1-4.1-0.1-4.2c-0.1-3-2.8-16.3-3-18.6 C64.2,10.7,62.8,10.4,62.6,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D9D9C",
    d: "M62.3,27.7c0,0,2.6-2.5,2.9-1c0.2,0.7-1.4-7.6-1.4-7.6l-0.3-5.9l-0.3,7.3L62.3,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#716F6F",
    strokeWidth: 0.563,
    strokeMiterlimit: 10,
    d: "M62.4,28c0,0,1.2-14.8,1.1-15.3 c-0.1-0.4-0.3,5,0.8,8.9c0.4,1.5,1.2,6.4,1.2,6.4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPleated2A);
export default __webpack_public_path__ + "static/media/pleated2a.4d841926c92c6ddc640baefeb6dc0637.svg";
export { ForwardRef as ReactComponent };